
export default {
  name: 'AppTabMenu',
  props: {
    useRouteLinks: Boolean,
    disableSwitch: Boolean,
    disableArrows: Boolean,
    value: {
      type: String,
      default: ''
    },
    listClass: {
      type: String,
      default: 'gap-4 md:gap-14'
    },
    items: {
      type: Array,
      required: true,
      default () {
        return []
      }
    }
  },
  data () {
    let activeItem = this.value

    if (!activeItem) {
      for (const item of this.items) {
        if (item.default) {
          activeItem = item.name

          break
        }
      }
    }

    return {
      activeItem,
      scrollingArrows: false
    }
  },
  watch: {
    value (newValue) {
      this.activeItem = newValue
    }
  },
  mounted () {
    this.updateScrollingArrows()
    window.addEventListener('resize', this.updateScrollingArrows)
  },
  destroyed () {
    window.removeEventListener('resize', this.updateScrollingArrows)
  },
  methods: {
    updateScrollingArrows () {
      const scrollContainer = this.$refs.scrollContainer
      const outerContainer = this.$refs.outerContainer

      if (!this.disableArrows) {
        this.scrollingArrows = scrollContainer && outerContainer && scrollContainer.scrollWidth > outerContainer.clientWidth
      }
    },
    scroll (direction) {
      const scrollContainer = this.$refs.scrollContainer

      if (!scrollContainer) {
        return
      }

      this.scrollTo(scrollContainer, scrollContainer.scrollLeft + (direction * 100))
    },
    scrollTo (scrollContainer, x) {
      if (typeof scrollContainer.scroll === 'function') {
        scrollContainer.scroll({ left: x, behavior: 'smooth' })
      } else {
        scrollContainer.scrollLeft = x
      }
    },
    changeItem (menuItem) {
      if (this.useRouteLinks || this.disableSwitch) {
        return
      }

      this.activeItem = menuItem
      this.$emit('input', menuItem)
    }
  }
}
